import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Card } from 'antd';
import DragHandle from '@components/common/DnD/DragHandle';
import { CSS } from '@dnd-kit/utilities';

interface FlowCardWrapperProps {
  fid: string;
  children: React.ReactNode;
  title: React.ReactNode;
  style?: React.CSSProperties;
  extra?: React.ReactNode;
  onContextMenu?: (e: React.MouseEvent) => void;
}

function FlowCardWrapper({
  fid,
  children,
  title,
  style = {},
  extra = <></>,
  onContextMenu,
}: FlowCardWrapperProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: fid });

  const dndStyle: any = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Card
      id={fid}
      size="small"
      title={title}
      style={{ ...dndStyle, ...style }}
      extra={
        <>
          {extra}
          <DragHandle {...attributes} {...listeners} />
        </>
      }
      ref={setNodeRef}
      onContextMenu={onContextMenu}
    >
      {children}
    </Card>
  );
}

export default FlowCardWrapper;
